import React from 'react'
import { Container } from 'reactstrap'

import PTEScoreCalculator from '../component/PTEScoreCalculator'
import IELTSscore from '../component/NEBGrade'
import SEEGPACalculator from '../component/SEEgpa'
import IELTSScoreCalculator from '../component/IELTSCalculator'
const scorecalculator = () => {
  return (
    <div className='page-content'>
        <Container fluid>
            {/* <SEEGPACalculator/> */}
            {/* <IELTSscore/> */}
            <PTEScoreCalculator />
            {/* <IELTSScoreCalculator/> */}
        </Container>
    </div>
  )
}

export default scorecalculator